document.addEventListener('DOMContentLoaded', function () {
  var script = document.querySelector('script[src*="Sortable.min.js"]');
  if (script) {
    script.parentNode.removeChild(script);
  }
});

(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.stickyNavbar = {
    attach: function (context, settings) {
      window.addEventListener('scroll', function (e) {
        document.getElementById('navbar-main').classList.toggle('sticky', window.scrollY > 0);
      }, { passive: true });
    }
  };

  Drupal.behaviors.menu_responsive = {
    attach: function (context, settings) {
      once('menu_responsive', document.querySelectorAll('.toggle-menu'), context).forEach(function (menu) {

        menu.onclick = function () {
          document.getElementsByTagName('body')[0].classList.toggle('show-frontMenu');
        }

      });
    }
  };

  Drupal.behaviors.bs_dropdown_menu = {
    attach: function (context, settings) {
      once('bs_dropdown_menu', document.querySelectorAll('.dropdown-menu'), context).forEach(function (menu) {

        menu.onclick = function (e) {
          e.stopPropagation();
        }

      });
    }
  };

  Drupal.behaviors.bsDropdownApproach = {
    attach: function (context, settings) {
      once('bsDropdownApproach', document.querySelectorAll('.dropdown-menu'), context).forEach(function (dropdown) {

        dropdown.onclick = function (ev) {
          ev.stopPropagation();
        }

      });
    }
  };

  Drupal.behaviors.headerSearchBlock = {
    attach: function (context, settings) {
      once('headerSearchBlock', document.querySelectorAll('.toggle-main-search'), context).forEach(function (search) {

        search.onclick = function () {
          document.getElementById('header-search').classList.toggle('hide');
          if (!document.getElementById('header-search').classList.contains('hide')) {
            document.querySelector('#views-exposed-form-search-page #edit-result').focus();
          } else {
            document.activeElement.blur();
          }
        }

      });
    }
  };

  Drupal.behaviors.overlayFilters = {
    attach: function (context, settings) {
      once('overlayFilters', document.querySelectorAll('.paragraph > .overlay-filter'), context).forEach(function (button) {
        const icon = button.querySelector('.bi');

        if (icon) {
          const toggleFilters = function (e) {
            if (e.type === 'keydown' && e.key !== 'Enter') {
              return;
            }

            const viewElement = button.nextElementSibling;

            if (viewElement) {
              const filters = viewElement.querySelector('.view-filters');

              if (filters) {
                filters.classList.toggle('show');
              }
            }
          };

          icon.onclick = toggleFilters;
          icon.onkeydown = toggleFilters;
        }
      });

      once('overlayFilters', document.querySelectorAll('.node--type-indicator.node--view-mode-full .view[class*="view-indicator-data-"] > .overlay-filter'), context).forEach(function (button) {
        const icon = button.querySelector('.bi');

        if (icon) {
          const toggleFilters = function (e) {
            if (e.type === 'keydown' && e.key !== 'Enter') {
              return;
            }

            const filters = button.nextElementSibling;

            if (filters && filters.classList.contains('view-filters')) {
              filters.classList.toggle('show');
            }
          };

          icon.onclick = toggleFilters;
          icon.onkeydown = toggleFilters;
        }
      });
    }
  };

  Drupal.behaviors.moveHeaderBeforeFiltersAtopaSaude = {
    attach: function (context, settings) {
      once('moveHeaderBeforeFiltersAtopaSaude', document.querySelectorAll('.view-resources-map .attachment'), context).forEach(function (attachment) {
        const attachment_header = attachment.querySelector('.view-header');
        const view_filters = attachment.previousElementSibling;
        attachment.parentElement.insertBefore(attachment_header, view_filters);
      });
    }
  };

  Drupal.behaviors.sliderBsCarouselPauseControl = {
    attach: function (context, settings) {
      once('sliderBsCarouselPauseControl', document.querySelectorAll('.carousel-control-pause'), context).forEach(function (control) {

        control.onclick = function (ev) {
          const carousel = ev.target.parentElement.parentElement.parentElement;
          const carouselInstance = bootstrap.Carousel.getInstance(carousel);

          if (carouselInstance !== null) {
            if (carousel.dataset.bsPause == "false") {
              carouselInstance.pause(); // Pausar el carousel si está en movimiento
              carousel.dataset.bsPause = "true";
              document.querySelectorAll("iframe").forEach(function (iframe) {
                iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
              });
            } else {
              carouselInstance.cycle(); // Reanudar el carousel si está pausado
              carousel.dataset.bsPause = "false";
              document.querySelectorAll("iframe").forEach(function (iframe) {
                iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
              });
            }
          }
        }

      });
    }
  };

  Drupal.behaviors.sliderBsCarouselVideoElementControl = {
    attach: function (context, settings) {
      once('sliderBsCarouselVideoElementControl', document.querySelectorAll('.carousel-item'), context).forEach(function (carousel_item) {

        const iframe = carousel_item.querySelectorAll('.views-field iframe');
        if (iframe.length > 0) {
          carousel_item.classList.add('has-video');

          if (carousel_item.offsetWidth * .5625 > carousel_item.offsetHeight) {
            iframe[0].style.minHeight = carousel_item.offsetWidth * 0.5625 + 'px';
          } else {
            iframe[0].style.minHeight = 'var(--carousel-inner-min-height)';
          }
          window.onresize = function (ev) {
            if (carousel_item.offsetWidth * .5625 > carousel_item.offsetHeight) {
              iframe[0].style.minHeight = carousel_item.offsetWidth * 0.5625 + 'px';
            } else {
              iframe[0].style.minHeight = 'var(--carousel-inner-min-height)';
            }
          }
        }

      });
    }
  };
})(Drupal, once);
